var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('grad-navbar',{attrs:{"active-path":_vm.$route.path,"nav-style":_vm.navCollapsed ? 'transition: transform .25s ease-in-out; transform: translateY(-100%);' : 'transition: transform .25s ease-in-out;'},on:{"gradpathchanged":_vm.onPathChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }